module.exports = __webpack_public_path__ + "static/img/2.2f8d5e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slide/2.jpg
// module id = JLkq
// module chunks = 1